import { useEffect, useState } from "react";
import { Box, Image, Loader } from "@mantine/core";

// Wraps Mantine's Image and shows a spinner overlay while the image at `src` is still
// loading, so the user knows something is happening instead of seeing a blank gap.
export function LoadingImage({ src, wrapperSx, spinnerSize = "sm", eager = false, ...imageProps }) {
  const [isLoading, setIsLoading] = useState(!!src);

  useEffect(() => {
    setIsLoading(!!src);
  }, [src]);

  if (!src) return null;

  return (
    <Box sx={{ position: "relative", width: "fit-content", display: "inline-block", ...wrapperSx }}>
      <Image
        src={src}
        imageProps={{
          onLoad: () => setIsLoading(false),
          onError: () => setIsLoading(false),
          // Lazy by default - every image except the always-visible header logo benefits from
          // not being fetched until it's near the viewport. Pass `eager` to opt out.
          loading: eager ? "eager" : "lazy",
        }}
        {...imageProps}
      />
      {isLoading && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Loader size={spinnerSize} />
        </Box>
      )}
    </Box>
  );
}
